// Slider extremes — sending these is equivalent to "no filter"
const SLIDER_REVENUE_MIN = 1000000;
const SLIDER_REVENUE_MAX = 999000000;
const SLIDER_EMPLOYEES_MIN = 0;
const SLIDER_EMPLOYEES_MAX = 500000;

/**
 * Collapse a bound value to null if it sits right at the slider extreme,
 * since the backend treats null as "unbounded" anyway.
 * The tiny epsilon absorbs floating-point noise from the log/exp slider math
 * (e.g. Math.exp(Math.log(1000000)) ≈ 999999.99999999) without swallowing
 * legitimate near-edge values like 1000001 or 999999.
 */
const SLIDER_EPSILON = 0.01;
const normalizeBound = (value, extreme) =>
  value != null && Math.abs(value - extreme) > SLIDER_EPSILON ? value : null;

export const buildSearchQuery = ({
  termsInclude,
  termsExclude,
  industryInclude,
  industryExclude,
  locations,
  revenueLowerBound,
  revenueUpperBound,
  employeesLowerBound,
  employeesUpperBound,
  naturalQuery,
  hasNaturalQuery,
}) => {
  if (hasNaturalQuery) {
    return {
      NaturalLanguageQuery: naturalQuery,
      OnlyNaturalLanguageQuery: true,
    };
  }

  return {
    TermsInclude: termsInclude,
    TermsExclude: termsExclude,
    IndustryInclude: industryInclude,
    IndustryExclude: industryExclude,
    Location: locations,
    RevenueLowerBound: normalizeBound(revenueLowerBound, SLIDER_REVENUE_MIN),
    RevenueUpperBound: normalizeBound(revenueUpperBound, SLIDER_REVENUE_MAX),
    EmployeesLowerBound: normalizeBound(employeesLowerBound, SLIDER_EMPLOYEES_MIN),
    EmployeesUpperBound: normalizeBound(employeesUpperBound, SLIDER_EMPLOYEES_MAX),
  };
};
